import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { FileCheck2, Download } from "lucide-react";
import { downloadCSV } from "@/lib/csv";

const fmt = (s) => (s ? new Date(s).toLocaleString() : "—");

export const AgreementsPanel = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/me/agreements").then(({ data }) => setItems(data.agreements || [])).catch(() => {});
  }, []);

  const exportCSV = () =>
    downloadCSV(
      "my-agreements.csv",
      items.map((a) => ({ agreement: a.title, version: a.version, accepted_at: a.accepted_at, ip: a.ip || "" }))
    );

  return (
    <div className="card-soft" data-testid="my-agreements-card">
      <div className="flex items-center justify-between gap-2 mb-3">
        <h2 className="font-heading text-xl text-[#1E3F33] flex items-center gap-2">
          <FileCheck2 className="w-4 h-4 text-[#2D6A4F]" /> My agreements
        </h2>
        {items.length > 0 && (
          <button
            type="button"
            data-testid="my-agreements-export"
            onClick={exportCSV}
            className="text-xs text-[#CC5A3A] font-medium inline-flex items-center gap-1.5 hover:underline"
          >
            <Download className="w-3.5 h-3.5" /> Export
          </button>
        )}
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-[#8A9A86]">No agreement records on file yet. Records are saved automatically when you accept agreements at sign-up.</p>
      ) : (
        <ul className="space-y-3">
          {items.map((a, i) => (
            <li key={i} className="border border-[#1E3F33]/10 rounded-xl p-3" data-testid={`my-agreement-${i}`}>
              <div className="text-sm font-medium text-[#1E3F33]">{a.title}</div>
              <div className="text-xs text-[#5C6B64] mt-1">Accepted {fmt(a.accepted_at)}</div>
              <div className="text-[11px] text-[#8A9A86] mt-0.5">Version {a.version}{a.ip ? ` · IP ${a.ip}` : ""}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
